import { initializeRootStore } from '@/stores';
import { getEnv, getSnapshot } from 'mobx-state-tree';
import HomeScene from '@/scenes/Home';
import { IBear } from '@/stores/Bears';
import StrapiService from '@/services/StrapiService';
import { useEffect, useState } from 'react';
import GalleryScene from '@/scenes/Gallery';

const BearPage = ({ pageContent }) => {
  const [type, setType] = useState<string>('');

  useEffect(() => {
    if (window.location.href.includes('rel=gallery')) {
      setType('gallery');
    } else {
      setType('home');
    }
  }, []);

  if (type === 'home') {
    return <HomeScene content={pageContent} />;
  }

  if (type === 'gallery') {
    return <GalleryScene />;
  }

  return <></>;
};

export const getStaticPaths = async () => {
  const strapiService = new StrapiService();

  const bears = await strapiService.getFeaturedBears();

  const paths = bears.map((bear: IBear) => {
    return {
      params: { url: bear.identifier },
    };
  });

  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps = async ({ params }) => {
  const rootStore = initializeRootStore();

  const strapiService = new StrapiService();
  const bear = await strapiService.getSingleBear(params.url);

  await rootStore.bearsStore.setItems([bear]);

  await rootStore.uiStore.openModal({ type: 'bear', instance: params.url });

  const pageContent = await getEnv(rootStore).strapiService.get('/home-page', {
    params: {
      'populate[banner][populate]': '*',
      'populate[aboutSection][populate]': '*',
      'populate[clubSection][populate]': '*',
      'populate[abominationsSection][populate]': '*',
      'populate[featuredBearsSection][populate]': '*',
      'populate[storiesSection][populate]': '*',
      'populate[bearpathSection][populate]': '*',
      'populate[team][populate]': '*',
      'populate[cta][populate]': '*',
    },
  });

  return {
    revalidate: 10,
    props: {
      initialState: getSnapshot(rootStore),
      pageContent: pageContent.data.data.attributes,
    },
  };
};

export default BearPage;
